module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_ny_dnhb.6977ecd4.png";